import {Bioma} from "./Bioma";
import {Municipio} from "./Municipio";
import {Taxon} from "./Taxon";
import {Monitoramento} from "./Monitoramento";
import {Pessoa} from "./Pessoa";
import {TipoMarcacao} from "./TipoMarcacao";
import {MeteorologiaEspecime} from "./MeteorologiaEspecime";
import {Comportamento} from "./Comportamento";
import {
  Acionamento,
  ClasseEtaria,
  Destino,
  Dinamica,
  EstagioMaturacao,
  FormaRegistro,
  Sexo,
  SimNaoAparente,
  SituacaoEspecime,
  Tempo
} from "./enums";
import {Arquivo} from "./Arquivo";
import {Column, Entity, JoinColumn, OneToMany, Point, PrimaryGeneratedColumn} from "typeorm/browser";
import {JoinTable, ManyToMany, ManyToOne} from "typeorm";
import {Fitofisionomia} from "./Fitofisionomia";
import {MicroRH} from "./MicroRH";
import {Entidade} from "./Entidade";
import {MetodoAmostragem} from "./MetodoAmostragem";

@Entity("especime")
export class Especime extends Entidade{
  @Column()//{type: "datetime"})
  dataHora?: string
  @Column()
  observacoes?: string
  @ManyToOne(() => Taxon, {cascade: true})
  @JoinColumn({ name: "taxon_id" })
  taxon?: Taxon
  @ManyToOne(() => Bioma)
  @JoinColumn({ name: "bioma_id" })
  bioma?: Bioma
  @ManyToOne(() => Fitofisionomia, {cascade: true})
  @JoinColumn({ name: "fitofisionomia_id" })
  fitofisionomia?: Fitofisionomia
  @JoinColumn({ name: "municipio_id" })
  @ManyToOne(() => Municipio, {cascade: true})
  municipio?: Municipio
  @JoinColumn({ name: "microrh_id" })
  @ManyToOne(() => MicroRH, {cascade: true})
  microRH?: MicroRH
  // @JoinColumn({ name: "cursodagua_id" })
  // @ManyToOne(() => CursoDagua, {cascade: true})
  // cursoDagua?: CursoDagua
  // @Column({spatialFeatureType: "point"})
  @Column("simple-json")
  ponto?: Point
  @JoinColumn({ name: "monitoramento_id" })
  @ManyToOne(() => Monitoramento, {cascade: true})
  monitoramento?: Monitoramento
  @Column()
  sexo?: Sexo
  @Column()
  classeEtaria?: ClasseEtaria
  @Column()
  tempo?: Tempo
  @Column()
  dinamicaSocial?: Dinamica
  @JoinColumn({ name: "comportamento_id" })
  @ManyToOne(() => Comportamento, {cascade: true})
  comportamento?: Comportamento
  // @JoinColumn({ name: "especime_id", referencedColumnName: "observadores_id" })
  @ManyToMany(() => Pessoa, {cascade: true})
  // @JoinTable({name:"especime_pessoa"})

  @JoinTable({
    name: 'especime_pessoa',
    joinColumn: {
      name: 'especime_id',
      referencedColumnName: 'id',
    },
    inverseJoinColumn: {
      name: 'observadores_id',
      referencedColumnName: 'id',
    },
  })
  observadores?: Pessoa[]
  @JoinColumn({ name: "guia_id" })
  @ManyToOne(() => Pessoa, {cascade: true})
  guia?: Pessoa
  @Column("simple-array")
  formasRegistro: FormaRegistro[] = []
  @Column()
  comprimentoTotal?: number
  @Column()
  comprimentoCabeca?: number
  @Column()
  comprimentoCauda?: number
  @Column()
  comprimentoAsa?: number
  @Column()
  comprimentoTarso?: number
  @Column()
  diametroTarso?: number
  @Column()
  pesoCorporal?: number
  @Column()
  comprimentoBico?: number
  @Column()
  larguraBico?: number
  @Column()
  alturaBico?: number
  @Column()
  gorduraSubcutanea?: number
  @Column()
  placaIncubacao?: string
  @Column()
  mudaPenas?: string
  @Column()
  destino?: Destino
  @Column()
  numeroTombamento?: string
  @Column()
  numeroMarcacao?: string
  @Column()
  alturaDossel?: number
  @Column()
  individuos?: number =1
  @Column()
  temperaturaAr?: number
  @Column()
  comprimentoRostroCloacal?: number
  @Column()
  comprimentoPadrao?: number
  @Column()
  estagioMaturacaoGonadal?: EstagioMaturacao
  @Column()
  comprimentoCorpo?: number
  @Column()
  comprimentoPataTraseira?: number
  @Column()
  larguraCabeca?: number
  @Column()
  comprimentoTronco?: number
  @Column()
  alturaCinturaPelvica?: number
  @Column()
  larguraCinturaPelvica?: number
  @Column()
  circunferenciaTorax?: number
  @Column()
  circunferenciaCabeca?: number
  @Column()
  circunferenciaPescoco?: number
  @Column()
  comprimentoOrelha?: number
  @Column()
  distanciaInterOlhos?: number
  @Column()
  larguraMandibula?: number
  @Column()
  prenha?: SimNaoAparente
  @Column()
  lactando?: SimNaoAparente
  @Column()
  numeroFilhotes?: number
  @Column()
  glandulasMamarias?: SimNaoAparente
  @Column()
  aberturaVaginal?: SimNaoAparente
  @Column()
  escrotado?: SimNaoAparente
  @Column()
  comprimentoPe?: number
  @Column()
  comprimentoAnteBraco?: number
  @Column()
  acionamento?: Acionamento
  @Column()
  estado?: SituacaoEspecime
  @Column()
  necrocia?: boolean
  @Column()
  oleado?: SimNaoAparente
  @Column("date")
  dataHoraSoltura?: Date
  @Column()
  areaSoltura?: string
  @JoinColumn({ name: "instituicaodepositaria_id" })
  @ManyToOne(() => Pessoa, {cascade: true})
  instituicaoDepositaria?: Pessoa
  @JoinColumn({ name: "tipomarcacao_id" })
  @ManyToOne(() => TipoMarcacao, {cascade: true})
  tipoMarcacao?: TipoMarcacao
  @OneToMany(() => MeteorologiaEspecime, (met) => met.especime, {cascade: true})
  meteorologias!: MeteorologiaEspecime[]
  @OneToMany(() => Arquivo, (arquivo) => arquivo.especime, {cascade: true})
  arquivos!: Arquivo[]
  @Column()
  agencia_sigla?: string

  @ManyToOne(() => MetodoAmostragem)
  @JoinColumn({ name: "metodoamostragem_id" })
  metodoAmostragem?: MetodoAmostragem
}


